export default {
	"审卷":'審卷',
	"修改记录":'修改記錄',
	"修改用户":'修改用户',
	"修改时间":'修改時間',
	"暂无记录":'暫無記錄',
	"上一页":'上一頁',
	"下一页":'下一頁',
	"修改题目":'修改題目',
	"详细数据":'詳細資料',
	"请先确认上一个产品":'請先確認上一個產品',
	"请选择地址":'請選擇位址',
	"问卷视图":'問卷視圖',
	"产品视图":'產品視圖',
	"产品员视图":'產品員視圖',
	"桌":'桌',
	"当前没有问卷进行中":'當前沒有問捲進行中',
	"停留时间":'停留時間',
	"第":'第',
	"个产品":'個產品',
	"页":'頁',
	"共":'共',
	"未开始":'未開始',
	"已完成":'已完成',
	"已结束":'已結束',
	"进行中":'進行中',
	"甄别问卷":'甄别問卷',
	"产品问卷":'產品問卷'
}